var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "pivot-table-widget",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.setSelected($event)
        },
      },
    },
    [
      !_vm.isNoData
        ? _c(
            "div",
            {
              staticClass: "statistic-box",
              style: {
                color:
                  _vm.cutField.options &&
                  _vm.cutField.options.setChartStyle.useTextColor,
              },
            },
            [
              _c("div", { staticClass: "statistic-metrics yichu" }, [
                _c(
                  "span",
                  {
                    staticClass: "sub-text",
                    style: {
                      "font-size":
                        _vm.cutField.options &&
                        _vm.cutField.options.setChartStyle.currencySymbolSize +
                          "px",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.cutField.options &&
                          _vm.cutField.options.setChartStyle.currencySymbol
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("span", {}, [_vm._v(_vm._s(_vm.metricsNum))]),
                _vm._v(" "),
                _vm.numericUnits
                  ? _c("span", { staticClass: "sub" }, [
                      _vm._v(_vm._s(_vm.numericUnits)),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _c("div", { staticClass: "no-data" }, [
            _vm._v("\n    请通过右侧\n    "),
            _c("span", { staticClass: "lh" }, [_vm._v("维度指标设置")]),
            _vm._v(" 维度、指标栏来添加数据\n  "),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }